import { assign } from 'lodash';
import { state as baseState, STATE_KEYS as BASE_STATE_KEYS } from '../base-collection/state';
import { FEATURE_FLAGS } from '../../../common/consts';

const STATE_KEYS = assign({}, BASE_STATE_KEYS, {
  IS_FIRST_TIME_USER: 'isFirstTimeUser',
  ONBOARDING_ITEMS: 'onboardingItems',
  STARTED_VIDEO_URL: 'startedVideoUrl',
  FEATURE_FLAGS: 'featureFlags',
});

const state = assign({}, baseState, {
  [STATE_KEYS.IS_FIRST_TIME_USER]: false,
  [STATE_KEYS.STARTED_VIDEO_URL]: '',
  [STATE_KEYS.ONBOARDING_ITEMS]: [],
  [STATE_KEYS.FEATURE_FLAGS]: {
    [FEATURE_FLAGS.SHOW_WIDGETS_TAB]: false,
  },
});

export {
  state,
  STATE_KEYS,
};
